var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85.95 87.84"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.63 87.84l-6.45-20.82H26.76l-6.45 20.82H0L31.39 0h23.05l31.51 87.84H65.63zM54.68 51.46c-5.96-18.87-9.32-29.54-10.07-32.01s-1.29-4.43-1.61-5.86c-1.34 5.11-5.17 17.73-11.5 37.88h23.17z",
    fill: "#f59c27"
  })));
}
export default SvgA;